const config = window.LoginPageSettings;

export default config;
